import {API_GIFTSHOP_UPLOAD_LINK, API_GIFTSHOP_UPLOAD_SUBMIT} from 'consts/api'
import {ServiceMap} from 'types/commons'
import {getAPIBaseUrl} from 'utils/commons'
import {ServiceParamGifthop} from './ServiceParamGiftshop'

export const SERVICE_MAP_GIFTSHOP: ServiceMap<ServiceParamGifthop> = {
  giftshop_upload_link: {
    url: getAPIBaseUrl() + API_GIFTSHOP_UPLOAD_LINK,
    method: 'POST',
  },
  giftshop_upload_submit: {
    url: getAPIBaseUrl() + API_GIFTSHOP_UPLOAD_SUBMIT,
    method: 'POST',
  },
}
